import { Draft } from '@reduxjs/toolkit';
import { PrivateAssetResult } from '@ff-os/shared-utils/types/private-assets/PrivateAssetResult';
import { Size } from '@ff-os/shared-utils/types/Size';
import { GiftJson } from '@ff-scene-plugins/gift-shared/GiftJson';
import { hasUserInput } from '@gift-variable-plugins/photo-shared/hasUserInput';
import { PhotoVariableInput, ProcessedPhotoInput } from '@gift-variable-plugins/photo-shared/PhotoVariableInput';
import { PhotoUploadData } from './PhotoUploadData';

export const handleSuccess = (
    input: Draft<GiftJson.Input<PhotoVariableInput>>,
    requestMeta: PhotoUploadData,
    result: PrivateAssetResult<Size>
) => {

    if (!hasUserInput(input.value) || input.value.cuid !== requestMeta.cuid) {
        return;
    }

    input.value.processed = true;

    // Uploads returned from backend are processed, the following check ensures
    // typescript asserts the correct type
    if (!input.value.processed) {
        return;
    }

    input.value.status = 'saved';
    input.value.assetSource = 'private';
    input.value.assetId = result.assetId;

    const { width, height } = result.meta;

    // Fix images with xmp tag orientations 5 - 8 #17453
    const isNormalized = width === input.value.imageHeight && height === input.value.imageWidth;

    if (!requestMeta.processed || isNormalized) {
        setImageSizeProperties(input.value, { width, height });
    }
};

const setImageSizeProperties = (
    input: Draft<ProcessedPhotoInput>,
    { width, height }: Size
) => {
    input.imageWidth = width;
    input.imageHeight = height;
    input.cropBox = {
        x: 0,
        y: 0,
        width: width,
        height: height
    };
};